import { Result, ok, err } from '../../../tracking-api';

export interface TinCanLaunchParameters {
  endpoint: string;
  actor: string;
  auth: string | null;
  registration: string | null;
  activityId: string | null;
}

export interface TinCanLaunchParameterError {
  code: 'missing-required-parameter';
  parameters: Array<'endpoint' | 'actor'>;
}

export class TinCanLaunchParametersResolver {

  public resolve(): Result<TinCanLaunchParameters, TinCanLaunchParameterError> {
    const params = this.collectParams();
    const missingParams: Array<'endpoint' | 'actor'> = [];
    if (!params.endpoint) {
      missingParams.push('endpoint');
    }
    if (!params.actor) {
      missingParams.push('actor');
    }

    if (missingParams.length > 0) {
      return err({ code: 'missing-required-parameter', parameters: missingParams });
    }

    return ok({
      ...params,
      endpoint: params.endpoint!,
      actor: params.actor!
    });
  }

  private collectParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      endpoint: params.get('endpoint'),
      actor: params.get('actor'),
      auth: params.get('auth'),
      registration: params.get('registration'),
      activityId: params.get('activity_id')
    };
  }
}
